import { fileSizeUnits } from '@app/core/_constant/common.constants';

class ImageUtility {
  convertFromBytes(value :number = 0) :string {
    let idx = 0;
    while (value >= 1024 && ++idx) {
      value = value / 1024;
    }

    return value.toFixed(value < 10 && idx > 0 ? 1 : 0) + ' ' + fileSizeUnits[idx];
  }
}

export const imageUtility = new ImageUtility();
